// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1YCRR","title":"styles_title__3x138"};